import { Person } from "../models/person-viewmodel";
import { ISearchResult, IPersonSearchResult, IAddress } from "../models/search-model";

export default class SearchMapper {
    public mapSearchResult(item: ISearchResult): Person | undefined {
        let person: IPersonSearchResult = item.Model;

        return new Person(
            item.id,
            `${person.Surname}, ${person.Initials} ${person.Insertion ?? ""} (${person.Firstname})`,
            person.Organisations?.map((x) => x.Name).join(" / "),
            person.Organisations?.map((x) => x.Department).join(" / "),
            person.Organisations?.map((x) => x.Function).join(" / "),
            person.Location?.Address?.BuildingName,
            person.PhoneNumbers?.map(x => x.Number),
            person.EmailAddresses?.map(x => x.Email),
            person.Location?.RoomNumber
        );
    }
}
